/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';

import { Container, Grid, LinearProgress, makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import IconClose from '../../assets/images/ic-close-round.svg';
import UploadVideoReportProgressDetailElementFinish from '../../components/uploadVideoReportProgress/UploadVideoReportProgressDetailElementFinish';
import UploadVideoReportProgressDetailElementLoading from '../../components/uploadVideoReportProgress/UploadVideoReportProgressDetailElementLoading';
import UploadVideoReportProgressFailed from '../../components/uploadVideoReportProgress/UploadVideoReportProgressFailed';
import UploadVideoReportProgressFinishDescription from '../../components/uploadVideoReportProgress/UploadVideoReportProgressFinishDescription';
import UploadVideoReportProgressLoadingDescription from '../../components/uploadVideoReportProgress/UploadVideoReportProgressLoadingDescription';
import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'block',
      margin: '0px',
      padding: '36px 24px',
      width: 'auto',
      [theme.breakpoints.up('lg')]: {
        padding: '36px 36px 50px',
        width: '700px',
      },
    },
    iconClose: {
      cursor: 'pointer',
      height: '24px',
      width: '24px',
    },
    linearFinishContainer: {
      margin: '20px 0px 30px',
    },
    linearProgressContainer: {
      margin: '70px 0px',
    },
    text: {
      textAlign: 'center',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '36px',
      textAlign: 'center',
    },
  };
});

export default ({ shouldRemoveFileUploadDetail }) => {
  const classes = useStyles();
  const history = useHistory();
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [userDetail, setUserDetail] = useState(null);
  const blocRef = useBlocRef('uploadProgressBloc');

  useEffect(() => {
    const progressSubscription = blocRef.current.progress$.subscribe(setProgress);
    const uploadingSubscription = blocRef.current.uploading$.subscribe(setUploading);
    const userDetailSubscription = blocRef.current.userDetails$.subscribe(setUserDetail);

    return () => {
      progressSubscription.unsubscribe();
      uploadingSubscription.unsubscribe();
      userDetailSubscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleIconCloseClick = () => {
    blocRef.current.close();
  };

  const handleClickBackToDashboard = () => {
    history.push('/patient-dashboard');
    blocRef.current.close();
  };

  const isFailed = progress < 100 && !uploading;
  const titleText = progress === 100 ? 'Video Report Request Complete' : 'Uploading Files ';
  const renderLoadingDescriptionElement = progress === 100 ? <UploadVideoReportProgressFinishDescription /> : <UploadVideoReportProgressLoadingDescription progress={progress} />;
  const linearContainerClass = progress === 100 ? classes.linearFinishContainer : classes.linearProgressContainer;
  const renderDetailElement =
    progress === 100 ? (
      <UploadVideoReportProgressDetailElementFinish
        userDetail={userDetail}
        removeFileUploadDetail={shouldRemoveFileUploadDetail}
        onClickBackToDashboard={handleClickBackToDashboard}
      />
    ) : (
      <UploadVideoReportProgressDetailElementLoading />
    );

  return (
    <Container disableGutters className={classes.container}>
      <Grid container justify="center" direction="column">
        <Grid item xs={12}>
          <div style={{ marginBottom: '16px', textAlign: 'right' }}>
            <img onClick={handleIconCloseClick} src={IconClose} alt="Icon Close" className={classes.iconClose} />
          </div>
          {isFailed ? (
            <UploadVideoReportProgressFailed progress={progress} />
          ) : (
            <>
              <Typography className={classes.typographyTitle}>{titleText}</Typography>

              <div className={`${linearContainerClass}`}>
                <div>{renderLoadingDescriptionElement}</div>
                <LinearProgress value={progress} style={{ height: 5, width: '100%' }} variant="determinate" />
              </div>

              <div>{renderDetailElement}</div>
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
